export default __webpack_public_path__ + "static/poster-a41ba9583e4903d4aec4459ff3291609.png";